import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./omnivore_pos_type.js";
//#region src/omnivore_pos_type_helper.ts
var omnivore_pos_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(posType) {
	switch (posType) {
		case "mock": return "Test POS";
		case "micros3700": return "Micros 3700";
		case "simphony1": return "Micros Simphony 1 (FE)";
		case "simphony_18_2": return "Micros Simphony 18.2";
		case "simphony": return "Micros Simphony 2";
		case "ncrAloha": return "NCR Aloha";
		case "brink": return "PAR Brink";
		case "positouch": return "Positouch";
	}
}
//#endregion
export { name, omnivore_pos_type_helper_exports };

//# sourceMappingURL=omnivore_pos_type_helper.js.map